import { render, staticRenderFns } from "./AnnouncementRow.vue?vue&type=template&id=9d6f8fee&"
import script from "./AnnouncementRow.vue?vue&type=script&lang=js&"
export * from "./AnnouncementRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports